import React from 'react';
import { Helmet } from 'react-helmet';
var Facebook = function (_a) {
    var url = _a.url, type = _a.type, title = _a.title, description = _a.description, image = _a.image, name = _a.name;
    return (React.createElement(Helmet, null,
        type && React.createElement("meta", { property: "og:type", content: type }),
        url && React.createElement("meta", { property: "og:url", content: url }),
        title && React.createElement("meta", { property: "og:title", content: title }),
        description && React.createElement("meta", { property: "og:description", content: description }),
        image && description && React.createElement("meta", { property: "og:image:alt", content: description }),
        image && React.createElement("meta", { property: "og:image", content: image }),
        name && React.createElement("meta", { property: "og:site_name", content: name })));
};
export default Facebook;
//# sourceMappingURL=Facebook.js.map